import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Translation } from 'react-i18next';

import { Link } from 'react-router-dom';

import './ProSectionPlaceholder.css';

class ProSectionPlaceholder extends Component {
  static propTypes = {
    locked: PropTypes.bool,
    className: PropTypes.string,
    children: PropTypes.oneOfType([
      PropTypes.element,
      PropTypes.arrayOf(PropTypes.element),
      PropTypes.string,
    ]).isRequired,
    proLabel: PropTypes.bool,
    text: PropTypes.string,
    bordered: PropTypes.bool,
  };

  static defaultProps = {
    locked: null,
    className: null,
    proLabel: null,
    text: '',
    bordered: null,
  };

  calculateClassName = () => {
    const { className, bordered } = this.props;
    let value = 'pro-section-placeholder__component';
    if (className) { value += ` ${className}`; }
    if (bordered) { value += ' bordered'; }
    return value;
  };

  render() {
    const { locked, children, proLabel, text } = this.props;

    return (
      <Translation>
        {(t) => (
          <div className={this.calculateClassName()}>
            {proLabel && <div className="pro-label">PRO</div>}
            {locked ?
              <>
                <div className="pro-section-placeholder-content">
                  <div className="image" />
                  <div className="text">
                    <span>{text}</span>
                    &nbsp;<Link to="/billing">{t("here")}</Link>
                  </div>
                </div>
                <div className="pro-section-placeholder-locked">
                  {children}
                </div>
              </>
              :
              <>
                {children}
              </>
            }
          </div>
        )}
      </Translation>
    );
  }
}

export default ProSectionPlaceholder;
